import { render, staticRenderFns } from "./PixItems.vue?vue&type=template&id=0503d5bb&scoped=true"
import script from "./PixItems.vue?vue&type=script&lang=js"
export * from "./PixItems.vue?vue&type=script&lang=js"
import style0 from "./PixItems.vue?vue&type=style&index=0&id=0503d5bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0503d5bb",
  null
  
)

export default component.exports